<template>
    <div>
        <slot>
            <oc-icon v-if="state" type="check" class="checked-icon" />
            <oc-icon v-else type="times" class="unchecked-icon" />
        </slot>
    </div>
</template>

<script>
import OriginalComponent from '../../../CheckboxInput'

export default {
    name: OriginalComponent.name + '-view',
    extends: OriginalComponent
}
</script>

<style scoped>
    .checked-icon {color: #28a745;}
    .unchecked-icon {color: #dc3545;}
</style>
